import { urlValidation } from 'src/app/common/function';
import { ActivatedRoute, Router } from '@angular/router';
import { ArticleHighlightModelComponent } from '../article-elements/article-highlight-model/article-highlight-model.component';
import { ImageLayoutType } from '../article-elements/article-image-layout-model/article-image-layout-model.component';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../../../services/loader.service';
import { ArticleService } from '../../../services/article.service';
import * as _ from 'lodash';
import {
  ArticleAccessLevelType,
  ArticleBlock,
  ArticleElement,
  ArticleTag,
  Article,
  CreateArticle,
  CarouselData,
  ArticleElementType,
  ArticleStatus,
  ArticleLanguageType,
} from '../../../models/article';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DndDropEvent } from 'ngx-drag-drop';
import { DeepCompare, getEnumToList, hasContentInHTMLTags } from '../../../common/function';
import { Subject, takeUntil, zip } from 'rxjs';
import { ArticleImageLayoutModelComponent } from '../article-elements/article-image-layout-model/article-image-layout-model.component';
import { JsonPipe } from '@angular/common';
import { TranslationPopupComponent } from '../translation-popup/translation-popup.component';
import { TranslationService } from '../../../services/translation.service';

export class ArticleLevel {
  public value: number;
  public text: string;
  public style: string;
  public description: string;
}

@Component({
  selector: 'app-article-edit',
  templateUrl: './article-edit.component.html',
  styleUrls: ['./article-edit.component.scss'],
})
export class ArticleEditComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('myDropdown', { static: true }) myDropdown: NgbDropdown;
  @ViewChild('dropdownMenu') dropdownMenuRef!: ElementRef;
  @ViewChild('scrollBarContainer') scrollBarContainerRef!: ElementRef;
  @ViewChild('articleImageLayoutModel', { static: true })
  articleImageLayoutModel: ArticleImageLayoutModelComponent;
  @ViewChild('translation') translationComponent!: TranslationPopupComponent;
  @ViewChild('articleHighlight', { static: true })
  articleHighlightModelComponent: ArticleHighlightModelComponent;

  articleTopicList: ArticleTag[] = [];
  selectTags: ArticleTag[] = [];
  dropdownSettings = {};
  articleElementList: ArticleElement[] = [];
  selectLanguage: ArticleLanguageType;
  selectLevel: ArticleAccessLevelType;
  articleAccessLevelType = ArticleAccessLevelType;
  articleLangaugeType = ArticleLanguageType;
  articleElementType = ArticleElementType;
  isEyeVisible: boolean = false;
  articleLevelList: ArticleLevel[] = getEnumToList(ArticleAccessLevelType);
  articleLanguageList: ArticleLevel[] = getEnumToList(ArticleLanguageType);
  isDragStart = false;
  articleBlockList: ArticleBlock[] = [];
  saveArticleBlockList: ArticleBlock[] = [];
  selectedElement: ArticleBlock;
  stopAnimation: boolean = false;
  articleId: number;
  cloneData: CreateArticle;
  articleStatusType = ArticleStatus;
  articleStatus: ArticleStatus;
  previousData: any;
  previousImages: any;
  restaurantData: string;
  scrollTimeout: any;
  modalReference: any;
  private destroy$ = new Subject<void>();
  translationBlockData: ArticleBlock[] = [];
  constructor(
    private articleService: ArticleService,
    private loaderService: LoaderService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private re: Router,
    private renderer: Renderer2,
    public translationService: TranslationService
  ) {
    this.selectLanguage = this.translationService.language == 'id' ? ArticleLanguageType.Indonesian : ArticleLanguageType.English;
  }

  loadData() {
    this.loaderService.setLoading(true);
    zip(
      this.articleService.getTopics(),
      this.articleService.getElements()
    ).subscribe(
      (res) => {
        if (res[0] && res[1]) {
          this.articleTopicList = res[0];
          this.articleElementList = res[1];

          this.articleLevelList.forEach((x) => {
            if (x.value == ArticleAccessLevelType.Public) {
              x.style = 'theme-pink';
              x.description = 'Some explanation sub text info';
            } else if (x.value == ArticleAccessLevelType.Connections) {
              x.style = 'theme-green';
              x.description = 'Some explanation sub text info';
            } else if (x.value == ArticleAccessLevelType.Followers) {
              x.style = 'theme-yellow';
              x.description = 'Some explanation sub text info';
            }
          });
          this.loaderService.setLoading(false);
          this.loadArticle();
        }
      },
      (err) => {
        this.loaderService.setLoading(false);
      }
    );
  }

  loadArticle() {
    if (!this.articleId) {
      return;
    }
    this.loaderService.setLoading(true);
    this.articleService.getById(`api/article?id=${this.articleId}`).subscribe((response: Article) => {
      this.setArticleData(response);
      this.loaderService.setLoading(false);
    }, (err) => {
      this.loaderService.setLoading(false);
      this.re.navigate(['/']);
    });
  }

  setArticleData(data: Article) {
    this.articleStatus = data.status;
    this.articleBlockList = data.articleBlocks;
    this.articleBlockList.forEach(x => {
      if (x.elementId === ArticleElementType.List) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = x.data;
        const firstChild = tempDiv.querySelector(':first-child');
        x.isTextWithIndentationInList = firstChild?.classList.contains('with-space-list');
      } else if (x.elementId === ArticleElementType.Image) {
        const carouselData = JSON.parse(x.data);
        x.imageCount = carouselData.Images.filter(x => x).length;
        x.layout = carouselData.Layout;
      } else if (x.elementId === ArticleElementType.MainImage) {
        x.originalImage = x.data;
      }
    });
    this.selectTags = this.articleTopicList.filter(x => data.tags.some(y => y == x.name));
    this.selectLevel = data.accessLevel;
    if (this.selectLanguage == null || this.selectLanguage == undefined) {
      this.selectLanguage = data.language ? data.language : ArticleLanguageType.English;
    }
    this.cloneData = JSON.parse(JSON.stringify({
      id: this.articleId,
      tags: this.selectTags?.map((x) => x.id),
      articleBlocks: this.articleBlockList,
      accessLevel: this.selectLevel,
      status: this.articleStatus,
      language: this.selectLanguage
    } as CreateArticle));
    this.translationBlockData = this.articleBlockList;
    if (this.selectLanguage == ArticleLanguageType.Indonesian) {
      this.articleBlockList = this.articleBlockList.map(item => ({
        ...item,
        data: item.translatedData
      }))
    }
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      if (params["articleId"]) {
        this.articleId = Number.parseInt(params["articleId"]);
      }

      this.dropdownSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'name',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 3,
        allowSearchFilter: false,
        limitSelection: 3,
      };

      this.loadData();
    });
    this.onDropdownShown();
    // Subscribe to language change events
    this.translationService.changeLangEmitted$
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => {
        this.selectLanguage = lang == 'id' ? ArticleLanguageType.Indonesian : ArticleLanguageType.English;
        this.loadData();
      });
  }

  onDrop(event: DndDropEvent) {
    this.stopAnimation = false;
    if (event.data.hasOwnProperty('elementId')) {
      // Sorting article elements
      const draggedItem = this.articleBlockList.find(x => x.displayOrder == event.data.displayOrder);
      const droppedIndex = event.index;

      this.articleBlockList = this.articleBlockList.filter(
        (item, index) => item.displayOrder !== draggedItem.displayOrder
      );
      this.articleBlockList.splice(droppedIndex, 0, draggedItem);
      this.reorder();
    } else {
      this.addElement(event.data, event.index);

      this.myDropdown.close();
    }
    this.dragOperationCompleted();
  }

  addElement(
    element: ArticleElement,
    index: number = this.articleBlockList?.length ?? 0
  ) {
    if (element.id === ArticleElementType.SubLine && !this.articleBlockList?.some(x => x.elementId === ArticleElementType.Header)) {
      this.toastr.error("You must add Header element for Subline");
      return;
    }

    if (element.id === ArticleElementType.Header && this.articleBlockList?.some(x => x.elementId === ArticleElementType.Header)) {
      this.toastr.error("You can only add one Header!");
      return;
    } else if (element.id === ArticleElementType.SubLine && this.articleBlockList?.some(x => x.elementId === ArticleElementType.SubLine)) {
      this.toastr.error("You can only add one SubLine!");
      return;
    } else if (element.id === ArticleElementType.Lead && this.articleBlockList?.some(x => x.elementId === ArticleElementType.Lead)) {
      this.toastr.error("You can only add one Lead!");
      return;
    }
    this.resetEdit();

    this.articleBlockList.forEach((x) => {
      x.isActiveForEdit = false;
    });

    // Add new article element
    let newBlock = {
      data: [
        ArticleElementType.Video,
        ArticleElementType.MainImage,
        ArticleElementType.Image,
      ].includes(element.id)
        ? ''
        : ' ',
      isActiveForEdit: true,
      elementId: element.id,
      type: element.type,
      displayOrder: index,
      layout: ImageLayoutType.layoutSecond,
      isInHighLightMode: false,
      images: ArticleElementType.Image == element.id ? new Array(4) : []
    } as ArticleBlock;
    this.previousData = '';
    this.previousImages = [];
    if (newBlock != null) {
      this.articleBlockList.splice(index, 0, Object.assign({}, newBlock));
    }
    this.reorder();
  }

  openForHighlight(element: ArticleBlock) {
    element.isInHighLightMode = true;
    this.previousData = JSON.parse(JSON.stringify(element.data));
    this.previousImages = JSON.parse(JSON.stringify(element.images));
  }

  editBlock(ele: ArticleBlock, index: number) {
    this.resetEdit();
    this.reorder();
    this.articleBlockList.forEach((x) => {
      x.isActiveForEdit = false;
      x.isInHighLightMode = false;
      if (ele.displayOrder == x.displayOrder && x.elementId === ArticleElementType.List) {
        x.data = x.cloneData;
        x.isTextWithIndentationInList = false;
      }
      if (x.elementId === ArticleElementType.Video) {
        x.isValidData = urlValidation(x.data)
      }
      const blockForEdit = Object.assign({}, this.articleBlockList[index]);
      blockForEdit.isActiveForEdit = true;
      this.articleBlockList[index] = blockForEdit;
      this.previousData = JSON.parse(JSON.stringify(ele.data));
      this.previousImages = JSON.parse(JSON.stringify(ele.images));
    });
  }

  saveBlock(ele: ArticleBlock) {
    if (ele.elementId === ArticleElementType.List && ele.isInHighLightMode) {
      const highlighArea = document.getElementById(`hightLightArea${ele?.displayOrder}`);
      var updateElement = this.articleBlockList.find(x => x.displayOrder == ele.displayOrder);
      updateElement.data = highlighArea?.innerHTML;
    }

    if (ele.elementId == ArticleElementType.Image &&
      (!ele.data || (JSON.parse(ele.data) as CarouselData).Images?.every(x => !x))) {
      this.toastr.error("Please select one Image!");
      return;
    }
    this.resetEdit();
    this.reorder();
    this.articleBlockList.forEach((x) => {
      x.isActiveForEdit =
        ele.displayOrder == x.displayOrder ? false : x.isActiveForEdit;
      x.isInHighLightMode = false;
    });
  }

  removeBlock(order: number) {
    if (this.articleBlockList.find(x => x.displayOrder == order).elementId === ArticleElementType.Header && this.articleBlockList.some(x => x.elementId === ArticleElementType.SubLine)) {
      this.toastr.error("Please remove the subline first!");
      return;
    }
    this.articleBlockList = this.articleBlockList.filter(
      (x) => x.displayOrder != order
    );
    this.reorder();
  }

  resetEdit() {
    let indexOfBlanckOpenElement = this.articleBlockList?.findIndex(
      (x) =>
        x.isActiveForEdit &&
        ((x.elementId != ArticleElementType.MainImage &&
          x.elementId != ArticleElementType.Image &&
          x.elementId != ArticleElementType.Video &&
          !hasContentInHTMLTags(x.data)) ||
          ((x.elementId == ArticleElementType.MainImage ||
            x.elementId == ArticleElementType.Image ||
            x.elementId === ArticleElementType.Video) &&
            !x.data))
    );
    if (indexOfBlanckOpenElement >= 0) {
      this.articleBlockList = this.articleBlockList.filter(
        (x, i) => i != indexOfBlanckOpenElement
      );
    }
  }

  addTextIndentation(ele: ArticleBlock) {
    if (!ele.isActiveForEdit) {
      const displayList = document.querySelector(`#displayElement${ele?.displayOrder}`);

      for (var i = 0; i < displayList?.children?.length; i++) {
        if (!ele.isTextWithIndentationInList) {
          displayList?.children[i].classList.add('with-space-list')
        } else {
          displayList?.children[i].classList.remove('with-space-list')
        }
      }

      ele.isTextWithIndentationInList = !ele.isTextWithIndentationInList;

      var updateElement = this.articleBlockList.find(x => x.displayOrder == ele.displayOrder);
      updateElement.data = displayList?.innerHTML;
    }
  }

  reorder() {
    const headerBlock = this.articleBlockList.find(x => x.elementId === ArticleElementType.Header);
    const sublineBlock = this.articleBlockList.find(x => x.elementId == ArticleElementType.SubLine);
    const leadBlock = this.articleBlockList.find(x => x.elementId === ArticleElementType.Lead);

    if (headerBlock && headerBlock.elementId === ArticleElementType.Header) {
      this.articleBlockList = this.articleBlockList.filter(x => x.elementId !== headerBlock.elementId);
      this.articleBlockList.splice(0, 0, headerBlock);
      if (headerBlock.isActiveForEdit && headerBlock.displayOrder != 0) {
        this.scrollTo(-document.body.scrollHeight);
      }
    }

    if (sublineBlock && sublineBlock.elementId === ArticleElementType.SubLine) {
      this.articleBlockList = this.articleBlockList.filter(x => x.elementId !== sublineBlock.elementId);
      this.articleBlockList.splice(1, 0, sublineBlock);
      if (sublineBlock.isActiveForEdit && sublineBlock.displayOrder != 1) {
        this.scrollTo(-document.body.scrollHeight);
      }
    }

    if (leadBlock && leadBlock.elementId === ArticleElementType.Lead) {
      this.articleBlockList = this.articleBlockList.filter(x => x.elementId !== leadBlock.elementId);
      this.articleBlockList.splice(this.articleBlockList?.length, 0, leadBlock);
      if (leadBlock.isActiveForEdit && leadBlock.displayOrder != ((this.articleBlockList?.length - 1) ?? 0)) {
        this.scrollTo(document.body.scrollHeight);
      }
    }

    this.articleBlockList.forEach((x, i) => {
      x.displayOrder = i;
    });
  }

  scrollTo(hight) {
    window.scrollTo({
      top: hight,
      behavior: 'smooth'
    });
  }

  optionChange(e: any) {
    this.selectLevel = e.value;
  }

  languageChange(e: any) {
    this.selectLanguage = e.value;
    this.loadData();
  }

  updateElement(e: ArticleBlock, index: number) {
    this.articleBlockList[index] = e;
    if (e.elementId == 11) {
      this.restaurantData = e.restaurantType;
    }
  }

  onImageCancel(e: ArticleBlock, index: number) {
    this.articleBlockList[index] = e;
    this.resetEdit();
    this.reorder();
  }

  // Modal Code
  private modalService = inject(NgbModal);
  openDeleteSectionModal(deleteSectionModal: TemplateRef<any>, order: number) {
    const modalRef = this.modalService.open(deleteSectionModal, {
      windowClass: 'delete-section-modal',
      centered: true,
      size: 'sm',
    });

    modalRef.result.then(
      (result) => {
        if (result) {
          // Execute the remove function or any other logic here
          this.removeBlock(order);
        }
      },
      (reason) => {
        // Handle modal dismissal or other reasons
      }
    );
  }

  identify(index: number, item: ArticleBlock) {
    return item.displayOrder;
  }

  resetDrags(restDragItemClass: string) {
    setTimeout(() => {
      const draggedElement = document.querySelectorAll(restDragItemClass);
      if (draggedElement) {
        draggedElement.forEach(x => {
          (x as HTMLElement).style.pointerEvents = 'auto';
        });
      }
    }, 200);
  }

  dragOperationCompleted() {
    const draggedElement = document.querySelector('.dndDraggingSource');

    if (draggedElement) {
      draggedElement.classList.remove('dndDraggingSource', 'dndDragging');
      (draggedElement as HTMLElement).style.pointerEvents = 'auto';
    }
  }

  onArticleBlockDragStart(e: any) {
    this.resetDrags('.article-area .post-comp-block');
  }

  onStart(e: any) {
    this.stopAnimation = true;
    this.resetDrags('.post-element-dropdown .dropdown-item');
  }

  openLayout(element: ArticleBlock) {
    this.articleImageLayoutModel.open();
    this.articleImageLayoutModel.blockElement = element;
    this.articleImageLayoutModel.selectedLayout = element.layout;
  }

  updateLayout(element: ArticleBlock) {
    let elementIndex = this.articleBlockList.findIndex(
      (x) => x.displayOrder == element.displayOrder
    );
    this.articleBlockList[elementIndex] = element;
  }

  async publishArticle() {
    const headerBlock = this.articleBlockList?.some(x => x.elementId === ArticleElementType.Header);
    const subLineBlock = this.articleBlockList?.some(x => x.elementId === ArticleElementType.SubLine);
    const mainImage = this.articleBlockList?.some(x => x.elementId === ArticleElementType.MainImage);
    const textElement = this.articleBlockList?.some(x => x.elementId === ArticleElementType.Text);

    if (!this.articleBlockList?.length || !headerBlock || !subLineBlock || !mainImage || !textElement) {
      this.toastr.error("The Article must contain at least one Header, Subline, Main Image and Text Blocks!")
      return;
    }

    if (!this.selectTags.length || this.selectLevel == null) {
      this.toastr.error("Please select Tags and Level!");
      return;
    }

    if (this.articleId) {
      this.cloneData.articleBlocks?.forEach(x => {
        if (x.elementId == ArticleElementType.List) {
          x['cloneData'] = '';
        }
      });
      this.articleBlockList.forEach(x => {
        if (x.elementId == ArticleElementType.List) {
          x['cloneData'] = '';
        }
      })
    }

    let data = {
      id: this.articleId,
      tags: this.selectTags?.map((x) => x.id),
      articleBlocks: this.articleBlockList,
      accessLevel: this.selectLevel,
      status: this.articleStatus,
      language: this.selectLanguage
    } as CreateArticle;

    if (!this.articleId || !DeepCompare(data, this.cloneData)) {
      await this.saveAsDraft(true);
    } else {
      this.publish();
    }
  }


  async saveAsDraft(isArticlePublic: boolean = false, isOpenTranslation: boolean = false) {

    if (this.articleBlockList.some(x => x.isActiveForEdit)) {
      this.toastr.error("Please save all blocks!");
      return;
    }

    this.articleBlockList = await this.setImagesForArticle(
      this.articleBlockList
    );

    if (this.selectLanguage == ArticleLanguageType.Indonesian) {
      if (this.articleId != null && this.articleId > 0) {
        this.articleBlockList = this.articleBlockList.map(item => ({
          ...item,
          translatedData: item.data,
          data: this.cloneData.articleBlocks.find(x => x.id == item.id).data
        }))
      }
      else {
        this.articleBlockList = this.articleBlockList.map(item => ({
          ...item,
          translatedData: item.data,
          data: ''
        }))
      }
    }

    let data = {
      id: this.articleId,
      tags: this.selectTags?.map((x) => x.id),
      articleBlocks: this.articleBlockList,
      accessLevel: this.selectLevel,
      language: this.selectLanguage
    } as CreateArticle;
    this.loaderService.setLoading(true);

    if (this.articleId) {
      this.articleService.updateArticle(data).subscribe(
        (res: Article) => {
          if (res) {
            this.setArticleData(res);
            if (!isArticlePublic) {
              this.toastr.success('Article Updated Successful!');
            }

            this.articleBlockList = res.articleBlocks;
            if (this.selectLanguage == ArticleLanguageType.Indonesian) {
              this.articleBlockList = this.articleBlockList.map(item => ({
                ...item,
                data: item.translatedData,
              }))
            }
            this.articleBlockList.forEach(x => {
              x.images = null;
            });
          }
          this.loaderService.setLoading(false);
          if (isArticlePublic) {
            this.publish();
          }
        },
        (err) => {
          this.loaderService.setLoading(false);
        }
      );
    } else {
      this.articleService.create('/api/article', data).subscribe(
        (res: Article) => {
          if (res) {
            if (!isArticlePublic) {
              this.toastr.success('Article Created Successful!');
              this.re.navigate(['article-edit', res.id]);
              this.articleId = res.id;;
              if (isOpenTranslation) {
                this.cloneData = JSON.parse(JSON.stringify({
                  id: this.articleId,
                  tags: this.selectTags?.map((x) => x.id),
                  articleBlocks: this.articleBlockList,
                  accessLevel: this.selectLevel,
                  status: this.articleStatus,
                  language: this.selectLanguage
                } as CreateArticle));
                this.translationBlockData = res.articleBlocks;
                this.openTranslationModal('project-modal edit-food-menu-modal');
              }
            } else {
              this.articleId = res.id;
              this.publish()
            }
          }
          this.loaderService.setLoading(false);
        },
        (err) => {
          this.loaderService.setLoading(false);
        }
      );
    }
  }

  publish() {
    this.loaderService.setLoading(true);
    this.articleService.publicArticleById(this.articleId).subscribe(res => {
      if (res) {
        this.toastr.success("Article Publish Successfully!");
        this.re.navigate(['article-preview', 1, this.articleId]);
      }
      this.loaderService.setLoading(false);

    }, err => {
      this.loaderService.setLoading(false);
    });
  }

  openHighLightModel(e: any) {
    this.articleHighlightModelComponent.open(e);
  }

  updateHighlightTextTitle(e: any) {
    let updateTag = document.querySelector(`#${e.id} .cus-tooltip`);
    let tooltipContent = document.querySelector(`#${e.id} .tooltip-content`);
    if (!tooltipContent) {
      const tooltipContentFragment = document
        .createRange()
        .createContextualFragment(
          `<span class="tooltip-content">${e.titleValue}</span>`
        );
      updateTag.appendChild(tooltipContentFragment);
    } else {
      tooltipContent.innerHTML = e.titleValue;
    }
  }

  isSaveButtonShow(element: ArticleBlock) {
    return (
      (element.isActiveForEdit &&
        element.elementId != ArticleElementType.MainImage) ||
      (element.elementId == ArticleElementType.List &&
        !element.isActiveForEdit &&
        element.isInHighLightMode)
    );
  }

  isSaveButtonDisable(element: ArticleBlock) {
    return ((element.elementId == ArticleElementType.Video && !element?.isValidData));
  }

  isEditButtonShow(element: ArticleBlock) {
    return (
      (!element.isActiveForEdit && element.elementId !== ArticleElementType.List) ||
      (!element.isInHighLightMode && !element.isActiveForEdit)
    );
  }
  convertFileToBytes(file: File): Promise<number[]> {
    return new Promise<number[]>((resolve, reject) => {

      const reader = new FileReader();

      reader.onload = () => {
        const arrayBuffer = reader.result as ArrayBuffer;
        const bytes = new Uint8Array(arrayBuffer);
        resolve(Array.from(bytes));
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsArrayBuffer(file);
    });
  }

  getFileExtension(file: File): string {
    const mimeType = file.type;
    const extension = mimeType.split('/').pop();
    return extension ? extension.toLowerCase() : '';
  }

  async setImagesForArticle(
    articleBlocks: ArticleBlock[]
  ): Promise<ArticleBlock[]> {
    await Promise.all(
      articleBlocks.map(async (block) => {
        if (block.images && block.images.length > 0) {
          await Promise.all(
            block.images.map(async (x) => {
              if (!x.imageInBytes?.length) {
                const bytes = await this.convertFileToBytes(x.image);
                const extension = this.getFileExtension(x.image);
                x.imageInBytes = bytes;
                x.extension = extension;
              }
            })
          );
        }
      })
    );

    articleBlocks.map((block) => {
      if (block.elementId === ArticleElementType.Image) {
        let carouselData = new CarouselData();
        carouselData.Layout = block.layout;
        block.data = JSON.stringify(carouselData);
      }
    });
    return articleBlocks;
  }

  openDiscardChangesModal(discardChangesModal: TemplateRef<any>, order: number) {
    const modalRef = this.modalService.open(discardChangesModal, {
      windowClass: 'delete-section-modal discard-changes-modal',
      centered: true,
      size: 'sm',
    });

    modalRef.result.then(
      (result) => {
        if (result) {
          let elementIndex = this.articleBlockList.findIndex(
            (x) => x.displayOrder == order
          );

          let element = Object.assign({}, this.articleBlockList[elementIndex]);
          element.data = JSON.parse(JSON.stringify(this.previousData));
          element.images = this.previousImages;
          element.isDiscardChanges = true;
          this.articleBlockList[elementIndex] = element;
          this.resetEdit();
          this.reorder();
          this.articleBlockList.forEach((x) => {
            x.isActiveForEdit =
              order == x.displayOrder ? false : x.isActiveForEdit;
            x.isInHighLightMode = false;
          });;
        }
      },
      (reason) => {
        // Handle modal dismissal or other reasons
      }
    );
  }

  onDropdownShown() {
    this.setDropdownHeight();
  }

  setDropdownHeight(retries = 10) {
    const dropdown1 = this.dropdownMenuRef?.nativeElement;
    const scrollContainer = this.scrollBarContainerRef?.nativeElement;
    if (!dropdown1 || !scrollContainer || retries === 0) return;
    const element = document.getElementById('dropdownBasic1');
    element.removeAttribute('ngbdropdowntoggle');
    const spaceFromTop = dropdown1.getBoundingClientRect();
    if (spaceFromTop.top > 0) {
      const windowHeight = window.innerHeight;
      const maxHeight = windowHeight - spaceFromTop.top - 30;
      scrollContainer.style.maxHeight = `${maxHeight}px`;

      scrollContainer.addEventListener('scroll', () => this.onScroll(scrollContainer), { passive: true });
    }
    else {
      setTimeout(() => this.setDropdownHeight(retries - 1), 50);
    }
  }

  openConfirmTransactionModal(confirmTransactionModal: TemplateRef<any>) {
    if (this.articleId > 0) {
      this.openTranslationModal('project-modal edit-food-menu-modal')
    }
    else {
      const modalRef = this.modalService.open(confirmTransactionModal, {
        windowClass: 'delete-section-modal',
        centered: true,
        size: 'sm',
      });

      modalRef.result.then(
        (result) => {
          if (result) {
            const headerBlock = this.articleBlockList?.some(x => x.elementId === ArticleElementType.Header);
            const subLineBlock = this.articleBlockList?.some(x => x.elementId === ArticleElementType.SubLine);
            const mainImage = this.articleBlockList?.some(x => x.elementId === ArticleElementType.MainImage);
            const textElement = this.articleBlockList?.some(x => x.elementId === ArticleElementType.Text);

            if (!this.articleBlockList?.length || !headerBlock || !subLineBlock || !mainImage || !textElement) {
              this.toastr.error("The Article must contain at least one Header, Subline, Main Image and Text Blocks!")
              return;
            }

            if (this.articleBlockList.some(x => x.isActiveForEdit)) {
              this.toastr.error("Please save all blocks!");
              return;
            }
            this.saveAsDraft(false, true);
            if (this.articleId) {
              this.openTranslationModal('project-modal edit-food-menu-modal');
            }
          }
        },
        (reason) => {
          // Handle modal dismissal or other reasons
        }
      );
    }
  }

  openTranslationModal(windowClass = '') {
    const modalRef = this.modalService.open(this.translationComponent.translationModalTemplate, {
      windowClass: windowClass,
      centered: true
    });
    this.modalReference = modalRef;
    this.translationComponent.originalArticleBlockList = this.translationBlockData ? this.translationBlockData : this.cloneData?.articleBlocks;
    this.translationComponent.articleId = this.articleId;
    this.translationComponent.articleBlockListData = this.articleBlockList;
    this.translationComponent.selectTags = this.selectTags;
    this.translationComponent.selectLevel = this.selectLevel;
    this.translationComponent.selectLanguage = this.selectLanguage;
    this.translationComponent.modalReference = this.modalReference;

    this.translationComponent.initializeTranslation();
    this.translationComponent.scrollTotop();

    modalRef.result.then(
      (result) => {
        if (result) {
          this.loadData();
        }
      })
      .catch(() => {
        this.modalService.dismissAll();
      })
  }

  ngAfterViewInit() {
    this.onDropdownShown();
  }

  @HostListener('window:resize')
  onResize() {
    this.setDropdownHeight();
  }

  onScroll(el: HTMLElement) {
    this.renderer.addClass(el, 'scrolling');
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }

    this.scrollTimeout = setTimeout(() => {
      this.renderer.removeClass(el, 'scrolling');
    }, 1000);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
